/* eslint-disable react/prop-types */
import React, { useEffect, useState, useReducer } from 'react';


import { Empty, Row, Col,  Button, Space, Table, Form, Input, Modal, Spin,  message , DatePicker ,Tabs , Typography , Popover, Select, Tag  } from 'antd';
import { Content } from 'antd/es/layout/layout';
import {  EditOutlined,DeleteOutlined, SnippetsOutlined,DownloadOutlined } from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import { TASK_LIST_DETAILS, TASK_LIST_DETAILS_SUCCESS, TASK_LIST_DETAILS_ERROR } from './constants';
import { TASK_LIST, TASK_LIST_SUCCESS, TASK_LIST_ERROR } from './constants';
import { ADD_TASK_LIST_DETAILS, ADD_TASK_LIST_DETAILS_SUCCESS, ADD_TASK_LIST_DETAILS_ERROR } from './constants';
import { UPDATE_TASK_LIST, UPDATE_TASK_LIST_DETAILS_SUCCESS, UPDATE_TASK_LIST_DETAILS_ERROR } from './constants';
import { DELETE_TASK_LIST, DELETE_TASK_LIST_SUCCESS, DELETE_TASK_LIST_ERROR } from './constants';



import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';

import { useFormik } from 'formik';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AllocationReducer from './reducer';
import TabPane from 'antd/es/tabs/TabPane';
import moment from 'moment';
import { useAuth } from '../Context';
import dayjs from 'dayjs';





export default function Tasknavigation(props) {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = {tasks : [], details: null, pending: false, error: false , pagination: { total: 0, limit: 10, skip: 0, current:1 }};
	const [data, dispatch] = useReducer(AllocationReducer, initalState);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const [showEditTasklistModal, setShowEditTasklistModal] = useState(false);
	const [showDeleteTasklistModal, setShowDeleteTasklistModal] = useState(false);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	// const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	const [openAttachmentModal, setShowAttachmentsModal] = useState(false);
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;
	const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);
	useAuth();
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const [notificationId,setNotificationId] = useState(null);
	let allocations = props.allocations;
	// const [showdate,setShowdate] = useState();
	const [regioninfoId ,setregioninfoId] = useState(null);
	const navigate = useNavigate();
	const {userId , usertypeId , showaddmodal , closeTasklistmodal , setShowAddModal , startDate , endDate} = props;

	let image_attachements = [];
	let video_attachements =[];
	let audio_attachements =[];

	const options = Array.isArray(allocations)
		? allocations.map((data) => ({
			label: `${data.regioninfo.regionName} ( ${data.pipelineConfigFrom} to ${data.pipelineConfigTo} )`,
			value: data.id,
			regionId : data.regioninfo.id   // or any id
		}))
		: allocations
			? [
				{
					label: `${allocations.regioninfo.regionName} ( ${allocations.pipelineConfigFrom} to ${allocations.pipelineConfigTo} )`,
					value: allocations.id,
					regionId : allocations.regioninfo.id 
				},
			]
			: [];

	const columns = [

		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
			
		},
		{
			title: langdata && langdata.AssignDate ? langdata.AssignDate : 'Assign Date',
			dataIndex: 'assignedDate',
			key: 'assignedDate',
			
		},
		{
			title: `${langdata && langdata.Allocation ? langdata.Allocation :'Allocation'}`,
			dataIndex: 'allocationId',
			key: 'allocationId',
			render: (_,record) => (
				<>
					{options && options.map((allocation) => { if (record.allocationId === allocation.value){ return allocation.label;} })}
				</>
			)
		},
		{
			title: langdata && langdata.Description ? langdata.Description :'Description',
			dataIndex: 'description',
			key: 'description',
			render: (text) => (
				<Popover title={langdata && langdata.Description ? langdata.Description :'Description'} content={text} trigger="hover">
					<Typography
						
					>
						{text}
					</Typography>
				</Popover>
			)
			
		},
		{
			title: langdata&&langdata.Remark?langdata.Remark:'Remark',
			dataIndex: 'remarks',
			key: 'remarks',
			
		},
		{
			title: langdata&&langdata.Status?langdata.Status:'Status',
			dataIndex: 'status',
			key: 'status',
			render: (_, { status }) => (
				<>
					<Tag color={status === 'New' ?'red' :'green'} >
						{status === 'New' ? langdata && langdata.New ? langdata.New : 'New' : langdata && langdata.Completed ? langdata.Completed : 'Completed'}
					</Tag>
				</>
			),
			
		},
		{
			title: langdata&&langdata.EndDate?langdata.EndDate:'End Date',
			dataIndex: 'endDate',
			key: 'endDate',
			
		},


		{
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				record.status.toLowerCase()!=='completed'?(
					<Space size="middle">
						<a title={langdata && langdata.EditTaskList ? langdata.EditTaskList : 'Edit Task List'} onClick={openEditTasklistModal}><EditOutlined/></a>
						<a title={langdata && langdata.DeleteTaskList ? langdata.DeleteTaskList : 'Delete Task List'} onClick={openDeleteTasklistModal}><DeleteOutlined /></a>
					</Space>
				) :
					(
						<Space size="middle">
							<a title={langdata && langdata.Attachments ? langdata.Attachments:'Attachments'} disabled={record.attachmentUrls.length <= 0} onClick={record.attachmentUrls.length > 0 ? openShowAttachments : null} ><SnippetsOutlined/></a>
						</Space>
					)
			)
		}
	];

	
	

	data?.details?.attachmentUrls? data.details.attachmentUrls.map((item)=>{

		const lower = item.toLowerCase().trim();
		if (lower.endsWith('.jpeg') || lower.endsWith('.jpg') || lower.endsWith('.png') || lower.endsWith('.svg') || lower.endsWith(' ')) {
			image_attachements.push(item);
		} else if (lower.endsWith('.mp3') || lower.endsWith('.wav') || lower.endsWith('.aac')|| lower.endsWith('.mpga')) {
			audio_attachements.push(item);
		} else if (lower.endsWith('.mp4') || lower.endsWith('.mov') || lower.endsWith('.avi') || lower.endsWith('.3gp') || lower.endsWith('.mkv') || lower.endsWith('.flv')) {
			video_attachements.push(item);
		}

	}):null;



	const openEditTasklistModal = () => {
		setShowEditTasklistModal(true);
	};

	const cloaseEditTasklistModal = () => {
		setShowEditTasklistModal(false);

	};

	const openDeleteTasklistModal = () => {
		setShowDeleteTasklistModal(true);
	};

	const closeShowAttachments = () => {
		setShowAttachmentsModal(false);
		
	};
	const openShowAttachments = () => {
		
		setShowAttachmentsModal(true);

	};

	const handleDownload = (imageUrl) => {
		fetch(imageUrl)
			.then(response => response.blob())
			.then(blob => {
			// Extract filename from URL
				const filename = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);
				const url = window.URL.createObjectURL(new Blob([blob]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', filename);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch(error => console.error('Error downloading image:', error));
	};
	


	const deletetasklist = () => {
		const id = parseInt(data.details.id);
    
		dispatch({ type: DELETE_TASK_LIST });

		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/tasklist/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_TASK_LIST_SUCCESS, payload: response});
					Modal.success({ title: langdata && langdata.TaskListDeletedSuccessfully ? langdata.TaskListDeletedSuccessfully : 'Task list deleted successfully' });
					setShowDeleteTasklistModal(false);   
					loadTasklist(1);       
				} else {
					dispatch({type:DELETE_TASK_LIST_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_TASK_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const closetasklistModal = () => {
		setShowDeleteTasklistModal(false);
	};

	useEffect(() => {
		if(!authtoken){
			navigate('/');
		}
	},[authtoken]);

	useEffect(() => {
		// if(featuresModule.speedClassificationEnabled == false) {
		// 	navigate('/dashboard');
		// }
		
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,4010);
	}, []);

	useEffect(()=>{
		loadNotificaitons();
	},[]);

	useEffect(() => {
		dispatch( { type: TASK_LIST });
      
		loadTasklist(1);
		
	}, [startDate, endDate]);

	const loadTasklist = (pagination) => {

		let _pagination = { };
		_pagination.total = data.pagination.total ? data.pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination.current    ? parseInt((pagination.current-1) * pagination.pageSize) : 0;
		_pagination.pageSize =  pagination.pageSize ? pagination.pageSize : 10;
		
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/tasklist?userId=${parseInt(userId)}&$sort[id]=-1&$limit=${_pagination.limit}&$skip=${_pagination.skip}&assignedDate[$gte]=${moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss')}&assignedDate[$lte]=${moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss')}&pipelineId=${pipelineId ? parseInt(pipelineId) : null}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {

				
				if (response.status === 200) {
					dispatch({type:TASK_LIST_SUCCESS, page:pagination.current, pageSize : pagination.pageSize , payload: response.data});
				}
				
			})
			.catch((error) => {
				dispatch({type:TASK_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const loadtasklistdetails = ((record) => {

		dispatch( { type: TASK_LIST_DETAILS });
    
		if (!record) {
			dispatch({ type: TASK_LIST_DETAILS_ERROR });
		} else {
			dispatch({ type: TASK_LIST_DETAILS_SUCCESS, payload: record });

		}

	});
	

	const dateHandler = (date,datetype) => {
	
		if(date && datetype === 'start'){
			const isodate = date && date.$d.toISOString();
			addTasklistFormik.setFieldValue('addTaskAssignDate', isodate);
		}
		else if (date && datetype === 'end') {
			const isodate = date && date.$d.toISOString();
			addTasklistFormik.setFieldValue('addTaskEndDate', isodate);

			

		}else if (date && datetype === 'updateStart') {
			const isodate = date && date.$d.toISOString();

			
			updateTasklistFormik.setFieldValue('updateTaskAssignDate', isodate);

		}else if (date && datetype === 'updateEnd' ) {
			const isodate = date && date.$d.toISOString();
			updateTasklistFormik.setFieldValue('updateTaskEndDate', isodate);
		}

	};

	const addstsnotification = (value) => {
		let config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: `${api}/stsnotification`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			},
			data: {
				notificationtypeId: notificationId,
				userId:userId,
				description:'New Task Added',
				regioninfoId:parseInt(regioninfoId),
				allocationId:parseInt(value),
				datetime:new Date().toISOString(),
				pipelineId:parseInt(pipelineId),
				// userId : userId,
				// usertypeId : usertypeId,
				// allocationId : null,
				// name : name,
				// assignedDate : assignedDate,
				// endDate : endDate,
				// description : description,
				// status : 'New',
				// pipelineId : parseInt(pipelineId),
	
			}
		};


      
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200 || response.status === 201) {
					setregioninfoId(null);
				}else{
					setregioninfoId(null);
				}
				
			})
			.catch((error) => {
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const addTasklistFormik = useFormik({
		// enableReinitialize: true,
		initialValues: {
			addTaskName: '',
			addTaskAssignDate: new Date().toISOString(),
			addTaskEndDate: null,
			addTaskDescription:'',
			addTaskRemark:'',
			addTaskStatus:'',
			allocationId : '',




		},
		onSubmit: (values) => {

			const name  = values.addTaskName ? values.addTaskName : '';
			const assignedDate = values.addTaskAssignDate;
			const endDate = values.addTaskEndDate ;
			const description = values.addTaskDescription ? values.addTaskDescription : '';
			const allocationId = values.allocationId ? values.allocationId  : '';

			if (!name || name == null || name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name.' });
				return false;
			}
			if (!assignedDate || assignedDate == null || assignedDate === '') {
				Modal.warning({ title: langdata && langdata.PleaseEnterAssignedDate ? langdata.PleaseEnterAssignedDate : 'Please enter  the  assigned date.' });
				return false;
			}
			if (!description || description == null || description === '') {
				Modal.warning({ title: langdata && langdata.PleaseEnterDescription ? langdata.PleaseEnterDescription : 'Please enter  the description.' });
				return false;
			}
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/tasklist`,
				timeout: timeout,
				headers: {
					accept: 'application/json', 
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					userId : userId,
					usertypeId : usertypeId,
					allocationId : allocationId,
					name : name,
					assignedDate : assignedDate,
					endDate : endDate,
					description : description,
					status : 'New',
					pipelineId : parseInt(pipelineId),

					
				}
			};

			dispatch( { type: ADD_TASK_LIST_DETAILS });
      
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: ADD_TASK_LIST_DETAILS_SUCCESS, payload: response});
						Modal.success({ title: langdata && langdata.TaskListSavedSuccessfully ? langdata.TaskListSavedSuccessfully : 'Task list saved successfully' });
						setShowAddModal(false);
						addTasklistFormik.resetForm();
						loadTasklist(1);
						addstsnotification(allocationId);
					} else {
						dispatch({type: ADD_TASK_LIST_DETAILS_ERROR});
						Modal.warning({ title: langdata && langdata.UnableToSaveTaskList ? langdata.UnableToSaveTaskList : 'Unable to save task list' });  
					}
				})
				.catch((error) => {
					dispatch({type: ADD_TASK_LIST_DETAILS_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});



	const updateTasklistFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			updateTaskName : data.details ? data.details.name : '',
			updateTaskAssignDate : data.details ? data.details.startassigndateUTC : '',
			updateTaskEndDate : data.details  ?  data.details.endtaskdateUTC  : null,
			updateTaskDescription : data.details ? data.details.description :'',
			updateTaskRemark : data.details ? data.details.remarks :'',
			updateTaskStatus : data.details ? data.details.status :'',
			allocationId : data.details ? data?.details?.allocationId :'',
			// startassigndateUTC : data.details ? data.details.startassigndateUTC : '',
			// endtaskdateUTC : data.details ? data.details.endtaskdateUTC : '',

		},
		onSubmit: (values) => {

			const id = data.details.id;
			const name = values.updateTaskName ? values.updateTaskName : '';
			const assignedDate = values.updateTaskAssignDate ? values.updateTaskAssignDate : '';
			const endDate = values.updateTaskEndDate ? values.updateTaskEndDate : '';
			const description = values.updateTaskDescription ? values.updateTaskDescription : '';
			const allocationId = values.allocationId ? values.allocationId  : '';
			
			
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/tasklist/${id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					name:name,
					assignedDate:assignedDate,
					endDate:endDate,
					description:description,
					status:'New',
					pipelineId : parseInt(pipelineId),
					allocationId : allocationId
					
				}
					
			};

			dispatch( { type: UPDATE_TASK_LIST });

			axios
				.request(config)
				.then((response) => {
		
					if (response.status === 200 || response.status === 201) {
						dispatch({type: UPDATE_TASK_LIST_DETAILS_SUCCESS, payload:response});
						Modal.success({ title: langdata && langdata.TaskListSavedSuccessfully ? langdata.TaskListSavedSuccessfully : 'Task list saved successfully' });
						setShowEditTasklistModal(false);
						updateTasklistFormik.resetForm();
						loadTasklist(1);
						addstsnotification(allocationId);
					} else {
						dispatch({type: UPDATE_TASK_LIST_DETAILS_ERROR});
						Modal.warning({ title: langdata && langdata.UnableToSaveTaskList ? langdata.UnableToSaveTaskList : 'Unable to save task list' });   
					}
				})
				.catch((error) => {
					dispatch({type: UPDATE_TASK_LIST_DETAILS_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});

	const loadNotificaitons = ()=>{
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/stsnotificationtype/?pipelineId=${pipelineId}&$sort[id]=-1&name=Task`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				
			},
		};
		// dispatch({type : NOTIFICATION_MANAGEMENT_LIST});
		axios.request(config)
			.then((response) => {
				setNotificationId(response?.data.data[0].id);
				if(response.status == 200 || response.status == 201){	
		
					// dispatch({ type : NOTIFICATION_MANAGEMENT_LIST_SUCCESS, payload: response.data.data });
				} else {
					// dispatch({ type : NOTIFICATION_MANAGEMENT_LIST_ERROR});			
				}
			})
			.catch((error) => {
				console.log(error);
				// dispatch({ type : NOTIFICATION_MANAGEMENT_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					// Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm.' });											
				}
			});
	};

	const handleAllocationId = (value, options ,type) =>{
		if(type === 'add'){					
			addTasklistFormik.setFieldValue('allocationId', value);
		}else if(type === 'edit'){
			updateTasklistFormik.setFieldValue('allocationId', value);
		}
		
		setregioninfoId( options.regionId);
		
		
	};

	

	return (
		

		<>
			<Content>
					
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						
						<Table
							scroll={{
								x: 900,
							}} 
							columns={columns} 
							dataSource={data.tasks} 
							pagination = { data.tasks.length > 0 ? data.pagination : 0 }
							onChange={loadTasklist}
							onRow = {(record) => {
								return {
									onClick: () => { 
										loadtasklistdetails(record);
											
												
									}
								};
							}}
									
						/>
					
					</Col>
				</Row>
			</Content>

			<Spin fullscreen spinning={data.pending} />
      
			{/* Add Task list Starts */}
			<Modal
				title={ langdata&&langdata.AddTaskList?langdata.AddTaskList:'Add Task List' }
				centered
				destroyOnClose={true}
				maskClosable={false}
				open={showaddmodal}
				onOk={closeTasklistmodal}
				onCancel={closeTasklistmodal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={closeTasklistmodal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
						{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addTasklistFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
					</Space>
				]}
				width={800}
			>
				<Form layout="vertical" onSubmit={addTasklistFormik.handleSubmit}>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="addTaskName" label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.PleaseEnterName ? langdata.PleaseEnterName : 'Please enter  name' }]} >
								<Input name="addTaskName" onChange={addTasklistFormik.handleChange} placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="allocationId" label={ langdata&&langdata.Allocation?langdata.Allocation:'Allocation'} rules={[{ required: true, message: langdata&&langdata.AddAllocation?langdata.AddAllocation:'Add Allocation' }]} >
								<Select name="allocationId" onChange={(value,options) =>{ handleAllocationId(value,options,'add'); }} placeholder={ langdata&&langdata.AddAllocation?langdata.AddAllocation:'Add Allocation'} options={options} />
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="addTaskAssignDate" label={langdata && langdata.AssignDate ? langdata.AssignDate : 'Assigned date'} rules={[{ required: true, message: langdata && langdata.PleaseEnterAssignedDate ? langdata.PleaseEnterAssignedDate : 'Please enter the assigned date' }]} >
								{/* <Input name="addTaskAssignDate" onChange={addTasklistFormik.handleChange} placeholder={langdata && langdata.PleaseEnterAssignedDate ? langdata.PleaseEnterAssignedDate : 'Please enter assigned date' } /> */}
								<DatePicker name="addTaskAssignDate" style={{ width: '100%'}} allowClear={false}  
									onChange={(date)=>{dateHandler(date, 'start'); }} format={settingsdateformat + ' ' + settingstimeformat}
									placeholder={langdata && langdata.PleaseEnterAssignedDate ? langdata.PleaseEnterAssignedDate : 'Please enter the assigned date'}
									defaultValue={dayjs(moment().format(settingsdateformat + ' ' + settingstimeformat), settingsdateformat) }  showTime/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="addTaskEndDate"label={langdata && langdata.EndDate ? langdata.EndDate : 'End date'}   >
									
								<DatePicker name="addTaskEndDate" style={{ width: '100%'}} allowClear={false}  
									placeholder={langdata && langdata.PleaseEnterEndDate ? langdata.PleaseEnterEndDate : 'Please enter the end date'}
									onChange={(date)=>{ dateHandler (date, 'end');}} format = {settingsdateformat  + ' ' + settingstimeformat} showTime/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="addTaskDescription" label={langdata && langdata.Description ? langdata.Description : 'Description'} rules={[{ required: true, message: langdata && langdata.PleaseEnterDescription ? langdata.PleaseEnterDescription : 'Please enter the description' }]} >
								{/* <Input name="addTaskDescription" onChange={addTasklistFormik.handleChange} placeholder={ langdata && langdata.PleaseEnterDescription ? langdata.PleaseEnterDescription : 'Please enter Description'} /> */}
								<TextArea  name="addTaskDescription" rows={4} onChange={addTasklistFormik.handleChange} placeholder={ langdata && langdata.PleaseEnterDescription ? langdata.PleaseEnterDescription : 'Please enter the  description'}/>
							</Form.Item>
						</Col>
					</Row>

                                            
				</Form>
			</Modal>
			{/* Add Task list  Ends */}

			{/* Edit Task list  Starts */}
			<Modal
				
				title={ langdata&&langdata.EditTaskList?langdata.EditTaskList:'Edit Task List'}
				centered
				destroyOnClose={true}
				maskClosable={false}
				open={showEditTasklistModal}
				onOk={cloaseEditTasklistModal}
				onCancel={cloaseEditTasklistModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={cloaseEditTasklistModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
						{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={updateTasklistFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
					</Space>
				]}
				width={800}
			>
				<Form layout="vertical" onSubmit={updateTasklistFormik.handleSubmit}>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="updateTaskName" label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'}]} >
								<Input name="updateTaskName" onChange={updateTasklistFormik.handleChange} placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'}  value={updateTasklistFormik.values.updateTaskName}  defaultValue={updateTasklistFormik.values.updateTaskName}/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="allocationId" label={ langdata&&langdata.Allocation?langdata.Allocation:'Allocation'} rules={[{ required: true, message: langdata&&langdata.AddAllocation?langdata.AddAllocation:'Add Allocation'}]} >
								<Select name="allocationId" onChange={(value,options) =>{ handleAllocationId(value,options,'edit'); }} 
									placeholder={ langdata&&langdata.AddAllocation?langdata.AddAllocation:'Add Allocation'} 
									options={options} 
									value={updateTasklistFormik.values.allocationId}  
									defaultValue={updateTasklistFormik.values.allocationId}/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="updateTaskAssignDate" label={langdata && langdata.AssignDate ? langdata.AssignDate : 'Assigned date'} rules={[{ required: true, message: langdata && langdata.PleaseEnterAssignedDate ? langdata.PleaseEnterAssignedDate : 'Please enter the assigned date' }]} >
								<DatePicker name="updateTaskAssignDate" style={{ width: '100%'}} allowClear={false} onChange={(date)=>{ dateHandler (date, 'updateStart');}} 
									format={settingsdateformat + ' ' + settingstimeformat }  
									placeholder = {langdata && langdata.PleaseEnterAssignedDate ? langdata.PleaseEnterAssignedDate : 'Please enter the assigned date'} 
									defaultValue={dayjs(new Date(updateTasklistFormik.values.updateTaskAssignDate))}  showTime/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="updateaddTaskEndDate"label={langdata && langdata.EndDate ? langdata.EndDate : 'End date'}   >
									
								<DatePicker name="updateaddTaskEndDate" style={{ width: '100%'}} allowClear={false} onChange={(date)=>{ dateHandler (date, 'updateEnd');}} 
									format={settingsdateformat + ' ' + settingstimeformat  } 
									// value = {updateTasklistFormik.values.updateTaskEndDate} 
									placeholder = {langdata && langdata.PleaseEnterEndDate ? langdata.PleaseEnterEndDate : 'Please enter the end date'} 
									defaultValue={updateTasklistFormik.values.updateTaskEndDate ? dayjs(new Date(updateTasklistFormik.values.updateTaskEndDate)):null}  showTime
								/>

							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="updateTaskDescription" label={langdata && langdata.Description ? langdata.Description : 'Description'} rules={[{ required: true, message: langdata && langdata.PleaseEnterDescription ? langdata.PleaseEnterDescription : 'Please enter the  description' }]} >
								<TextArea  name="updateTaskDescription" rows={4} onChange={updateTasklistFormik.handleChange}  
									defaultValue = {updateTasklistFormik.values.updateTaskDescription} 
									placeholder={langdata && langdata.PleaseEnterDescription ? langdata.PleaseEnterDescription : 'Please enter the  description'} />
							</Form.Item>
						</Col>
					</Row>
				</Form>
								
			</Modal>
			{/* Edit Speed Classification Ends */}

			{/* Delete Speed Classification Starts */}
			<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteTasklistModal} onOk={deletetasklist} onCancel={closetasklistModal}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}> { langdata && langdata.ConfirmDeleteTask ? langdata.ConfirmDeleteTask  : 'Are you sure you want to delete this Task?' }</Col>
				</Row>
			</Modal>
			{/* Edit TaskList Ends */}

			{/* Attachment Modal starts */}


				

			<Modal
				title={langdata && langdata.Attachments ? langdata.Attachments:'Attachments'}
				centered
				destroyOnClose={true}
				open={openAttachmentModal}
				onOk={{closeShowAttachments}}
				onCancel={closeShowAttachments}
				footer={[
				]}
				width={540}>
				<div  style={{ paddingTop: '20px',height:'400px',overflowY:'scroll' }}>

					<>
						<Tabs defaultActiveKey='1' style={{marginBottom:'10px'}}>
							<TabPane tab={langdata && langdata.Image ? langdata.Image : 'Image'} key='1'  >

								{image_attachements && image_attachements.length>0 ?

									image_attachements.map((item,index)=>(

										<div key={index}>
											<img  style={{width:'100%', height:'360px'}} src={item.trim()} alt='image' />

											<a target="_blank" href={item.trim()} onClick={() => {
												handleDownload(item.trim());
											}} rel="noreferrer" >
												<br/> 
												<DownloadOutlined style={{fontSize:'20px',marginTop:'5px',marginBottom:'20px'}}/> {langdata && langdata.Downloadfile ? langdata.Downloadfile:'Download file'}</a>
																


										</div>
									)):
									<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
								}

							</TabPane>

							<TabPane tab={langdata && langdata.Audio ? langdata.Audio : 'Audio'} key='2'>
								
								{audio_attachements && audio_attachements.length>0 ?
								
									audio_attachements.map((item,index)=>(
										<>
											<audio style={{width:'100%'}}  key={index} controls>
												<source src={item.trim()} />
								
								
								
											</audio>
								
								
											<a target="_blank" href={item.trim()} onClick={() => {
												handleDownload(item.trim());
											}} rel="noreferrer" >
												<br/> 
												<DownloadOutlined style={{fontSize:'20px',marginTop:'10px'}}/> {langdata && langdata.Downloadfile ? langdata.Downloadfile:'Download file'}</a>
																								
								
								
										</>
									)):
									<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
								
								}
								
							</TabPane>
							<TabPane tab={langdata && langdata.Video ? langdata.Video : 'Video'} key='3'>
								
								{video_attachements && video_attachements.length>0 ?
								
									video_attachements.map((item,index)=>(
										<>
											<video key={index} controls style={{width:'100%'}}>
												<source src={item.trim()} />
								
											</video>
								
											<a target="_blank" href={item.trim()} onClick={() => {
												handleDownload(item.trim());
											}} rel="noreferrer" >
												<br/> 
												<DownloadOutlined style={{fontSize:'20px',marginTop:'10px', marginBottom:'10px'}}/> {langdata && langdata.Downloadfile ? langdata.Downloadfile:'Download file'}</a>
																								
										</>
																							
									)):
									<Empty  image={Empty.PRESENTED_IMAGE_SIMPLE} />
								
								}
								
							</TabPane>
								
																					
								
						</Tabs>
					</>
				</div>
			</Modal>






		</> 


			
	);

	
}